import client from "../client";
import internalClient from "../internalClient";

export interface PrepareBulkUploadInput {
  file_type: string;
  original_filename: string;
}

export interface PreparedUpload {
  file_id: string;
  upload_url: string;
  fields: Record<string, string>;
}

export const prepareBulkUpload = (input: PrepareBulkUploadInput) => {
  return client({
    query: `mutation PrepareBulkUpload($input: PrepareBulkUploadInput) {
      prepare_bulk_upload(input: $input) {
        file_id
        upload_url
        fields
      }
    }`,
    variables: { input }
  });
};

export const internalPrepareBulkUpload = (input: PrepareBulkUploadInput) => {
  return internalClient({
    query: `mutation InternalPrepareBulkUpload($input: PrepareBulkUploadInput) {
      internal_prepare_bulk_upload(input: $input) {
        file_id
        upload_url
        fields
      }
    }`,
    variables: { input }
  });
};

export interface FileSearchFilter {
  file_ids?: string[];
  file_types?: string[];
  process_status?: string[];
  organisation_ids?: string[];
  actor_ids?: string[];
  date?: {
    min?: string;
    max?: string;
  };
  search_text?: string;
}

export interface SearchFileRequest {
  from?: number;
  size?: number;
  filter?: FileSearchFilter;
}

const SEARCH_FILE_FIELDS = `
  total_pages
  total_size
  files {
    file_id
    file_type
    process_status
    version
    created_at
    updated_at
    attributes {
      total_rows
      processed_rows
      key
      bucket_name
      date
      e_tag
      original_filename
      actor_id
      actor_role
      actor_organisation_id
      actor_name
      actor_organisation_name
    }
  }
`;

export const searchFile = (data: SearchFileRequest) => {
  return client({
    query: `query SearchFile($input: SearchInput) {
      search_file(input: $input) {
        ${SEARCH_FILE_FIELDS}
      }
    }`,
    variables: {
      input: {
        from: data.from,
        size: data.size,
        filter: {
          file_filter: data.filter
        }
      }
    }
  });
};

export const internalSearchFile = (data: SearchFileRequest) => {
  return internalClient({
    query: `query InternalSearchFile($input: SearchInput) {
      internal_search_file(input: $input) {
        ${SEARCH_FILE_FIELDS}
      }
    }`,
    variables: {
      input: {
        from: data.from,
        size: data.size,
        filter: {
          file_filter: data.filter
        }
      }
    }
  });
};

export interface FileContentSearchFilter {
  file_ids: string[];
  process_status?: string[];
  search_text?: string;
}

export interface SearchFileContentRequest {
  from?: number;
  size?: number;
  filter: FileContentSearchFilter;
}

const SEARCH_FILE_CONTENT_FIELDS = `
  total_pages
  total_size
  file_content_list {
    content_id
    file_id
    file_type
    process_status
    link_id
    link_type
    data
    err_message
    attributes
    content
  }
`;

export const searchFileContent = (data: SearchFileContentRequest) => {
  return client({
    query: `query SearchFileContent($input: SearchInput) {
      search_file_content(input: $input) {
        ${SEARCH_FILE_CONTENT_FIELDS}
      }
    }`,
    variables: {
      input: {
        from: data.from,
        size: data.size,
        filter: {
          file_content_filter: data.filter
        }
      }
    }
  });
};

export const internalSearchFileContent = (data: SearchFileContentRequest) => {
  return internalClient({
    query: `query InternalSearchFileContent($input: SearchInput) {
      internal_search_file_content(input: $input) {
        ${SEARCH_FILE_CONTENT_FIELDS}
      }
    }`,
    variables: {
      input: {
        from: data.from,
        size: data.size,
        filter: {
          file_content_filter: data.filter
        }
      }
    }
  });
};
